import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContactForm from './ContactForm';
import './Contact.css';

const copyToClipboard = async (text, label) => {
  try {
    await navigator.clipboard.writeText(text);
    // Show toast notification
    showToast(`Copied ${label} to clipboard!`);
  } catch (err) {
    console.error('Failed to copy:', err);
    showToast('Failed to copy to clipboard');
  }
};

const showToast = (message) => {
  // Remove existing toast if any
  const existingToast = document.querySelector('.copy-toast');
  if (existingToast) {
    existingToast.remove();
  }

  // Create new toast
  const toast = document.createElement('div');
  toast.className = 'copy-toast';
  toast.textContent = message;
  document.body.appendChild(toast);

  // Show toast
  setTimeout(() => toast.classList.add('show'), 10);

  // Hide and remove toast
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }, 2000);
};

const Contact = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: window.innerWidth <= 768 ? 0.05 : 0.2,
        rootMargin: '30px'
      }
    );

    const section = document.getElementById('contact');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const contactInfo = [
    {
      icon: '📧',
      label: 'Email',
      value: 'antonicieslak1997@gmail.com',
      href: 'mailto:antonicieslak1997@gmail.com',
      copyable: true
    },
    {
      icon: '📱',
      label: 'Phone',
      value: '+48 668 510 340',
      href: 'tel:+48668510340',
      copyable: true
    },
    {
      icon: '💼',
      label: 'LinkedIn',
      value: 'linkedin.com/company/apagedev',
      href: 'https://www.linkedin.com/company/apagedev/',
      copyable: true
    },
    {
      icon: '🎨',
      label: 'Artstation',
      value: 'artstation.com/apage',
      href: 'https://www.artstation.com/apage',
      copyable: true
    },
    {
      icon: '🌐',
      label: 'Portfolio',
      value: 'antonicieslakvfx.xg.pl',
      href: 'https://www.antonicieslakvfx.xg.pl/',
      copyable: true
    }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className={`contact-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="contact-title fade-in-up">
            {t('contact.title')}
          </h2>

          <div className="contact-grid">
            <div className="contact-info fade-in-up">
              <h3 className="info-title">{t('contact.subtitle')}</h3>
              <p className="info-description">
                {t('contact.description')}
              </p>

              <div className="contact-cards">
                {contactInfo.map((info, index) => (
                  <div key={index} className="contact-card-wrapper">
                    <a
                      href={info.href}
                      target={info.href.startsWith('http') ? '_blank' : '_self'}
                      rel={info.href.startsWith('http') ? 'noopener noreferrer' : ''}
                      className="contact-card"
                    >
                      <div className="card-icon">
                        <span className="icon-emoji">{info.icon}</span>
                      </div>
                      <div className="card-content">
                        <h4 className="card-label">{info.label}</h4>
                        <p className="card-value">{info.value}</p>
                      </div>
                    </a>
                    {info.copyable && (
                      <button
                        className="copy-button"
                        onClick={() => copyToClipboard(info.value, info.label)}
                        title="Copy to clipboard"
                      >
                        📋
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="contact-form-container fade-in-up">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;